import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.lastSubmitted = this.currentValues()
  }

  submit() {
    const { from, to } = this.currentValues()
    if (!from || !to) return
    if (from === this.lastSubmitted.from && to === this.lastSubmitted.to) return

    this.lastSubmitted = { from, to }
    this.formTarget.requestSubmit()
  }

  currentValues() {
    return {
      from: this.element.querySelector('[name="from"]')?.value,
      to:   this.element.querySelector('[name="to"]')?.value,
    }
  }
}
